import React from 'react';
import Slider from 'react-slick';
import Shape12 from '../../../assets/images/shape-12.png';
import Service1 from '../../../assets/images/Assitance.jpg';
import Service2 from '../../../assets/images/Guidance.jpg';
import Service3 from '../../../assets/images/Driving_Course.jpg';
import { config } from '../config';

const ServiceSection = () => {
  const Servcices = [
    {
      title: 'Automatic Driving Lessons',
      description:
        'Learn to drive confidently in an automatic car with patient, experienced instructors. Perfect for beginners and nervous learners.',
      image: Service3,
      link: `${config.appUrl}courses`,
    },
    {
      title: 'Manual Driving Lessons',
      description:
        'Master clutch control, gear changes, junctions and roundabouts with professional manual driving tuition.',
      image: Service1,
      link: `${config.appUrl}courses`,
    },
    {
      title: 'Intensive Driving Courses',
      description:
        'Fast-track your driving journey with structured intensive driving courses tailored to your experience level.',
      image: Service2,
      link: `${config.appUrl}courses`,
    },
    {
      title: 'Refresher Driving Lessons',
      description:
        'Regain confidence behind the wheel with personalised refresher lessons for qualified drivers.',
      image: Service1,
      link: `${config.appUrl}refresher-driver-lessons`,
    },
    {
      title: 'Mock Driving Test',
      description:
        'Prepare for your practical driving test with realistic mock tests and personalised feedback.',
      image: Service3,
      link: `${config.appUrl}about-practical-test`,
    },
    {
      title: 'Pass Plus Driving Lessons',
      description:
        'Continue building your driving skills after passing your test with Pass Plus training.',
      image: Service2,
      link: `${config.appUrl}courses`,
    },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      <section className="service-section py-5">
        <div className="shape">
          <div
            className="shape-1 float-bob-x"
            style={{ backgroundImage: `url(${Shape12})` }}
          ></div>
          <div
            className="shape-2 float-bob-x"
            style={{ backgroundImage: `url(${Shape12})` }}
          ></div>
        </div>
        <div className="auto-container">
          <div className="sec-title light centred mb-5">
            <h2>Services customised for you</h2>
          </div>
          <div className="service-carousel-wrapper">
            <Slider {...sliderSettings}>
              {Servcices?.map((serv, i) => {
                return (
                  <div key={i} className="px-3">
                    <div className="service-block-one mb-4">
                      <div className="inner-box h-100">
                        <div className="image-box">
                          <figure className="image">
                            <img src={serv?.image} alt={`${serv?.title}`} />
                          </figure>
                        </div>
                        <div className="lower-content">
                          <div className="text">
                            <h4>
                              <a href={serv?.link}>{serv.title}</a>
                            </h4>
                            <p className="">{serv?.description}</p>
                          </div>
                          <div className="lower-box d-flex justify-content-between align-items-center px-4 py-4 bg-white">
                            <div className="link w-100 d-flex justify-content-between align-items-center">
                              <a
                                href={serv?.link}
                                className="d-flex align-items-center justify-content-between w-100 fw-bold text-dark text-decoration-none read-more-link"
                              >
                                <span>READ MORE</span>
                                <i className="bi bi-arrow-right-circle-fill text-green fs-5"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceSection;
